import {
  ADD_USERS, GET_USER_LIST, USER_LIST_RESPONCE, EDIT_USER, EDIT_USER_STATUS, DELETE_USER,
  DELETE_USER_REDUX_STATE, EDIT_USER_STATUS_REDUX_STATE, EDIT_USER_SIGN_STATUS_REDUX_STATE, ADD_CSV_BULK_USERS
} from "./actionTypes";


/**
 * Action creator function that creates an action to add a user.
 * @param {Object} data - The user data to be added.
 * @param {string} token - The authentication token.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns {Object} - An action object with type, payload, success, and failure properties.
 */
export const addUser = (data, success, failure) => {
  return {
    type: ADD_USERS,
    payload: { data },
    success: (data) => success(data),
    failure: (data) => failure(data),
  }
}

/**
 * Action creator function to add bulk users from a CSV file.
 * @param {object} data - The data object containing the bulk user information.
 * @param {function} success - The success callback function.
 * @param {function} setter - The setter function to update the state.
 * @returns {object} An action object with the type, payload, success, and setter properties.
 */
export const addcsvBulkUser = (data, success, setter) => {
  return {
    type: ADD_CSV_BULK_USERS,
    payload: { data },
    success: success,
    setter: setter,
  }
}

/**
 * Returns an action object to get the user list.
 * @param {string} token - The user token.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns {object} - An action object with type, payload, success, and failure properties.
 */
export const getUserList = (success, failure) => {
  return {
    type: GET_USER_LIST,
    success: (data) => success(data),
    failure: (data) => failure(data),
  }
}

/**
 * Action creator function for a successful user list retrieval.
 * @param {any} data - The data returned from the API call.
 * @returns {object} An action object with the type USER_LIST_RESPONCE and the payload data.
 */
export const userListResponce = data => {
  return {
    type: USER_LIST_RESPONCE,
    payload: data,
  }
}

/**
 * Action creator function that creates an action to edit a user.
 * @param {string} id - The ID of the user to edit.
 * @param {object} data - The data to update the user with.
 * @param {string} token - The authentication token.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns An action object with type, payload, success, and failure properties.
 */
export const editUser = (id, data, success, failure) => {
  return {
    type: EDIT_USER,
    payload: { id, data },
    success: (data) => success(data),
    failure: (data) => failure(data),
  }
}

/**
 * Creates an action object for editing the status of a user.
 * @param {string} id - The ID of the user to edit.
 * @param {object} data - The data to update the user's status with.
 * @param {string} token - The authentication token.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns {object} An action object with type, payload, success, and failure properties.
 */
export const userEditStatus = (id, data, success, failure) => {
  return {
    type: EDIT_USER_STATUS,
    payload: { id, data },
    success: (data) => success(data),
    failure: (data) => failure(data),
  }
}

/**
 * Creates an action object for deleting a user.
 * @param {number} id - The ID of the user to delete.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns An action object with type, payload, success, and failure properties.
 */
export const userDelete = (id, success, failure) => {
  return {
    type: DELETE_USER,
    payload: { id },
    success: (data) => success(data),
    failure: (data) => failure(data),
  }
}

// redux Actions

/**
 * Action creator function to delete Redux state.
 * @param {any} data - The data to be passed as the payload of the action.
 * @returns {object} An action object with type DELETE_REDUX_STATE and the provided data as the payload.
 */
export const deleteUserReduxState = (data) => {
  return {
    type: DELETE_USER_REDUX_STATE,
    payload: data,
  }
}

/**
 * Action creator function that creates an action to edit the status in the Redux state.
 * @param {any} data - The data to be included in the action payload.
 * @returns {object} An action object with a type of EDIT_STATUS_REDUX_STATE and a payload of the provided data.
 */
export const editUserStatusReduxState = (data) => {
  return {
    type: EDIT_USER_STATUS_REDUX_STATE,
    payload: data,
  }
}

/**
 * Action creator function to edit the user sign status in the Redux state.
 * @param {any} data - The data to be updated in the Redux state.
 * @returns {object} - An action object with the type and payload.
 */
export const editUserSignStatusReduxState = (data) => {
  return {
    type: EDIT_USER_SIGN_STATUS_REDUX_STATE,
    payload: data,
  }
}